import React from "react";
import { PROCESS_STEPS } from "@/lib/mockData";
import { Phone, Users, BarChart3 } from "lucide-react";

const iconMap = { phone: Phone, users: Users, "bar-chart-3": BarChart3 };

const Process = () => {
  return (
    <section id="about" className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">How we work</p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-zinc-50"
            data-testid="process-heading"
          >
            From brief to billboard, in three sprints.
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {PROCESS_STEPS.map((s, idx) => {
            const Icon = iconMap[s.icon] || Phone;
            return (
              <div
                key={s.num}
                className="relative rounded-2xl border border-white/8 bg-white/[0.02] p-7 lg:p-8 transition-all duration-300 hover:border-blue-500/30"
                data-testid={`process-step-${idx + 1}`}
              >
                <div className="flex items-center justify-between">
                  <span className="text-5xl font-bold tracking-tighter text-zinc-800">
                    {s.num}
                  </span>
                  <div className="h-10 w-10 rounded-lg bg-blue-600/10 border border-blue-500/20 flex items-center justify-center">
                    <Icon className="h-5 w-5 text-blue-400" />
                  </div>
                </div>
                <h3 className="mt-5 text-xl font-semibold text-zinc-50 tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
